import angular from 'angular';

import { isUndefined, isFunction } from 'lodash';

import authInterceptor from './auth.interceptor';

const authModule = angular.module('meredicte.auth', []);

authModule
.factory('authInterceptor', authInterceptor)
.config(($httpProvider) => {
  $httpProvider.interceptors.push('authInterceptor');
})
.run(($rootScope, $state, AuthService) => {

  'ngInject';

  let currentState = null;

  // check user roles/permissions in order to know if it can go to the specified state:
  // default to "forbidden" state when conditions aren't met
  const checkRolesAndGo = (next, nextParams) => {
    const roles = next.access.roles && next.access.roles.length ? next.access.roles : false;

    currentState = next.name;
    if (roles) {
      if (AuthService.hasRoles(roles)) {
        currentState = next.name;
      } else {
        currentState = 'forbidden';
      }
    }

    $state.go(currentState, nextParams);
  };

  $rootScope.$on('$stateChangeStart', (event, next, nextParams) => {

    const needAuth = (isUndefined(next.access) ||
                      isUndefined(next.access.loginRequired)) ? true : next.access.loginRequired;
    const isUserLogged = AuthService.isAuthenticated();

    if (next.name === currentState) {
      return;
    }

    if (needAuth) {

      // Make a ping request to see if the user is logged in
      // AuthService.ping();

      event.preventDefault();

      if (!isUserLogged) {
        // navigate to the login state
        $state.go('login');
      } else if (!AuthService.isAuthenticated()) {
        // check if we already have a user
        AuthService.fetch()
        .then((response) => {
          AuthService.setCredentials(response.data);
          checkRolesAndGo(next, nextParams);
        })
        .catch((err) => {
          throw err;
        });
      } else {
        checkRolesAndGo(next, nextParams);
      }

    } else {
      checkRolesAndGo(next, nextParams);
    }
  });

  $rootScope.$on('$stateChangeSuccess', (event, next, nextParams) => {
    // change the page title
    const title = $state.$current.locals.globals.$title;

    /* eslint-disable no-param-reassign */
    $rootScope.$title = isFunction(title) ? title() : title;
    /* eslint-enable no-param-reassign */
    if (next.redirectTo) {
      event.preventDefault();
      const options = next.redirectTo.options || {};
      options.relative = next;
      $state.transitionTo(next.redirectTo.sref, nextParams, options);
    }
  });

  // that's what execute when the $state.resolve promise is rejected
  $rootScope.$on('$stateChangeError', (event, next, nextParams, prev, prevParams, error) => {
    console.log('$stateChangeError', { event, next, nextParams, prev, prevParams, error });

    if (isFunction(error.onError)) {
      // onError should be a function with the redirect purpose
      error.onError();
    }
  });

});

export default authModule;



// WEBPACK FOOTER //
// ./src/modules/auth/auth.module.js